export enum ApplicationType {
    PRIVATE = 'PRIVATE',
    PUBLIC = 'PUBLIC',
    DEFAULT = 'DEFAULT'
}
